// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-counter[data-v-1e99e11c]{border-radius:50%;width:28px;height:28px;position:absolute;background-color:#E63D24;color:white;text-align:center;line-height:28px;right:-10px;top:0}\n", ""]);
// Exports
module.exports = exports;
